import {HttpRequest} from "../utils/httpRequest";

let InviteDesign = {
    /**
     * 获取数据列表
     * @param params
     */
    getIvDesignList(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/design/list',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取所有数据
     * @returns {*}
     */
    getIvDesigns() {
        return HttpRequest.getRequest({
            url: '/edu/invite/design/all',
            method: 'get'
        });
    },
    /**
     * id 查询
     * @param id
     */
    getIvDesignInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/invite/design/info/' + id,
            method: 'get'
        });
    },
    /**
     * 新增或编辑数据
     * @param datas
     */
    addOrUpdateIvDesign(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/invite/design/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除数据
     * @param params
     * @returns {*}
     */
    deleteIvDesign(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/design/delete',
            method: 'get',
            data: params
        });
    }
};
export {InviteDesign}
